module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-UltraLight.19f22bc7.woff";